import styles from "./index.module.css";
import FakeButton from "../../../Components/FormComponents/FakeButton";
import { useNavigate } from "react-router-dom";

export function Greetings() {
  const navigation = useNavigate();
  return (
    <div className={styles.container}>
      <h1>Вітаємо!</h1>

      <div>
        Ваша оплата за зимовий інтенсив «WIN WINTER» успішно завершена.
        Очікуйте, поки з вами звʼяжуться ментори!
      </div>

      <div className={styles.button}>
        <FakeButton
          className={styles.homeButton}
          onClick={() => {
            navigation("/");
          }}
        >
          На головну
        </FakeButton>
      </div>
    </div>
  );
}

export function Pending({ awaitingApp }) {
  return (
    <div className={styles.container}>
      <h1>{awaitingApp ? "Підтверди оплату в застосунку" : "Перевіряємо оплату"}</h1>

      <div>
        {awaitingApp
          ? "Відкрий застосунок monobank і підтверди покупку частинами. Щойно банк підтвердить оплату, сторінка оновиться сама."
          : "Зачекай, будь ласка, поки ми отримаємо підтвердження від банку. Це зазвичай займає лише кілька секунд — сторінка оновиться сама."}
      </div>

      <div className={styles.spinner} aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

export function Failed() {
  const navigation = useNavigate();
  return (
    <div className={styles.container}>
      <h1>Оплата не пройшла</h1>

      <div>
        Схоже, під час оплати виникла помилка. Спробуй ще раз — це займе лише
        хвилину.
      </div>

      <div className={styles.button}>
        <FakeButton
          className={styles.homeButton}
          onClick={() => {
            navigation("/");
          }}
        >
          Спробувати ще раз
        </FakeButton>
      </div>
    </div>
  );
}
